import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import * as commonDate from 'libs/commonDate';

import { IUsr0201MState, IInquiryCndsState, IUseBirdState } from '../../models/usr/usr0201m_model';
  
const initialState: IUsr0201MState = {
    useBirdList : [],       // 생일현황
    inquiryCnds: {
        baseYm : commonDate.maskDateDefault(commonDate.getToday())
    },                      // 조회조건

    pageSize : 20,          // 페이징사이즈
    current  : 0,           // 현재페이지
}

export const usr0201m_Slice = createSlice({
    name: "usr0201m_Slice",
    initialState: initialState,
    reducers: {
        initState: (state) => {
            Object.assign(state, {...initialState});
        },
        setUserBirdList: (state, action:PayloadAction<IUseBirdState[]>) => {
            state.useBirdList = action.payload;
        },
        setInquiryCnds: (state, action:PayloadAction<IInquiryCndsState>) => {
            state.inquiryCnds = action.payload;
        },
        setPageSize: (state, action:PayloadAction<number>) => {
            state.pageSize = action.payload;
        },
        setCurrent: (state, action:PayloadAction<number>) => {
            state.current = action.payload;
        },
    },
});

export default usr0201m_Slice.reducer;
export const Usr0201mAction  = usr0201m_Slice.actions;
export const Usr0201mReducer = usr0201m_Slice.reducer;